import React from "react";
import { useParams } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import CalculatorShell from "../components/calculators/CalculatorShell";

export default function CalculatorDetailPage() {
    const { slug } = useParams();
    return (
        <div>
            <Navbar />
            <CalculatorShell slug={slug} />
            <Footer />
        </div>
    );
}
